import { render, staticRenderFns } from "./updatedSiteFooter.vue?vue&type=template&id=31e633f8&scoped=true"
import script from "./updatedSiteFooter.vue?vue&type=script&lang=js"
export * from "./updatedSiteFooter.vue?vue&type=script&lang=js"
import style0 from "./updatedSiteFooter.vue?vue&type=style&index=0&id=31e633f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e633f8",
  null
  
)

export default component.exports